module.exports = __webpack_public_path__ + "img/circle_1_4.ef1d5cf6.svg";